export const events = [
  { 
    id: 1, 
    title: "Os d'Ishango", 
    date: "20000 BCE", 
    location: "République Démocratique du Congo", 
    coordinates: [29.6, -0.1], 
    description: "L'un des plus anciens témoignages de calcul mathématique, cet os contient des entailles organisées suggérant une compréhension précoce des nombres et du comptage.",
    modelPath: "/assets/models/ishango_bone.obj",
    mapImage: "/assets/images/maps/congo_map.jpg"
  },
  { 
    id: 2, 
    title: "Pyramide de Kéops", 
    date: "2560 BCE", 
    location: "Égypte", 
    coordinates: [31.1, 29.9], 
    description: "Chef-d'œuvre architectural démontrant une maîtrise avancée de la géométrie, des mesures et des proportions mathématiques dans l'Égypte ancienne.",
    modelPath: "/assets/models/pyramid.obj",
    mapImage: "/assets/images/maps/egypt_map.jpg"
  },
  { 
    id: 3, 
    title: "Papyrus de Rhind", 
    date: "1550 BCE", 
    location: "Égypte ancienne", 
    coordinates: [30.8, 28.5], 
    description: "Document mathématique égyptien contenant 84 problèmes mathématiques avec solutions, incluant des calculs de fraction, d'aire et de volume.",
    modelPath: "/assets/models/papyrus_rhind.obj",
    mapImage: "/assets/images/maps/egypt_map.jpg"
  },
  { 
    id: 4, 
    title: "Village Ba-ila", 
    date: "1400 CE", 
    location: "Zambie", 
    coordinates: [10.5, 5.5], 
    description: "Architecture traditionnelle du peuple Bali au Cameroun, utilisant des concepts géométriques sophistiqués et des motifs fractals dans la construction et la décoration.",
    modelPath: "/assets/models/bali_village.obj",
    mapImage: "/assets/images/maps/cameroon_map.jpg"
  },
  { 
    id: 5, 
    title: "Manuscrits de Tombouctou", 
    date: "1400-1600 CE", 
    location: "Mali", 
    coordinates: [-3.0, 16.8], 
    description: "Collection de manuscrits du Mali contenant des traités mathématiques avancés sur l'algèbre, la géométrie et l'astronomie, témoignant de la riche tradition intellectuelle de l'Afrique de l'Ouest.",
    modelPath: "/assets/models/timbuktu_manuscript.obj",
    mapImage: "/assets/images/maps/mali_map.jpg"
  }
];